var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardIssuance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 30,
    height: 21.6667,
    rx: 4.76946,
    stroke: "url(#paint0_linear_623_3456)",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.668 25H11.6846",
    stroke: "url(#paint1_linear_623_3456)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 18.3337H35.0013",
    stroke: "url(#paint2_linear_623_3456)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_3456",
    x1: 5,
    y1: 20.8333,
    x2: 35,
    y2: 20.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_3456",
    x1: 11.668,
    y1: 25.5,
    x2: 11.6846,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_623_3456",
    x1: 6.66797,
    y1: 18.8337,
    x2: 35.0013,
    y2: 18.8337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIssuance);
export default __webpack_public_path__ + "static/media/card_issuance.a51f71b4864f95e638dcc107bf341c5b.svg";
export { ForwardRef as ReactComponent };